import { getHomePageContentfulData, getCommonContentfulData } from '../libs/repositories/contentful';
import Layout from '../components/common/Layout';
import Meta from '../components/common/Meta';
import AlertKv from '../components/section/common/AlertKv';
import Kv from '../components/section/top/Kv';
import Salads from '../components/section/top/Salads';
import Location from '../components/section/top/Location';
import Sites from '../components/section/top/Sites';
import Initiatives from '../components/section/top/Initiatives';
import Careers from '../components/section/common/Careers';

export default function Home({
    messages,
    megaBanners,
    subBanners,
    signatureSalads,
    serviceBanners,
    commonData,
}) {
    // 共通データからフッターバナーを取得
    const serviceSiteFooterBanner = commonData?.footerBanner;
    return (
        <Layout>
            <Meta
                title="CRISP SALAD WORKS│クリスプサラダワークス"
                description="カスタムサラダ専門店「CRISP SALAD WORKS」です。CRISPらしいレストラン体験で「A Small, Good Thing. (ちょっとした心の交流)」と、野菜たっぷりのサラダを届けていきたいなって思ってます。"
            />
            <AlertKv messages={messages} />
            <Kv mega_banners={megaBanners} sub_banners={subBanners} />
            {/* <Yap yapEntries={yapEntries} yapTitle={yapTitle} /> */}
            <Salads salads={signatureSalads} />
            <Location />
            <Sites serviceBanners={serviceBanners} />
            <Initiatives />
            <Careers serviceSiteFooterBanner={serviceSiteFooterBanner} />
        </Layout>
    );
}

export const getStaticProps = async () => {
    // 複数のContentful API呼び出しを1つにまとめる
    const [contentfulData, commonData] = await Promise.all([
        getHomePageContentfulData(),
        getCommonContentfulData()
    ]);

    return {
        props: {
            ...contentfulData,
            commonData,
        },
        // ISRを有効化: 60秒でページを再生成
        revalidate: 60,
    };
};


